/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */
export const PREVIEW_PANEL = '__pageLayoutPreviewPanel';
export const HORIZONTAL_NAVIGATION = '__pageLayoutHorizontalNavigation';
export const LEFT_SIDEBAR = '__pageLayoutLeftSidebar';
export const MAIN_CONTENT = '__pageLayoutMainContent';
export const TOP_NAVIGATION = '__pageLayoutTopNavigation';
export const RIGHT_SIDEBAR = '__pageLayoutRightSidebar';
export const REDIRECT = '___pageLayoutRedirect';
export const SPA_CONTENT = '__pageLayoutSpaContent';

export type PageLayoutField =
	| typeof PREVIEW_PANEL
	| typeof HORIZONTAL_NAVIGATION
	| typeof LEFT_SIDEBAR
	| typeof RIGHT_SIDEBAR
	| typeof MAIN_CONTENT
	| typeof TOP_NAVIGATION
	| typeof SPA_CONTENT
	| typeof REDIRECT;
